import React from "react";
import { Container } from "react-bootstrap";

type TCardProjectsBack = {
  projectName: string;
  shortDescription: string;
};
export const CardProjectsBack = ({
  projectName,
  shortDescription
}: TCardProjectsBack) => {
  return (
    <Container>
      <div className='title'>{projectName}</div>
      <div className='description'>{shortDescription}</div>
    </Container>
  );
};
